import { useState } from 'react';
import Excel from 'exceljs';
import Loader from '../../../Components/Spinner/Loader';
import { FaFileExcel } from 'react-icons/fa';
import { saveAs } from 'file-saver';
type IProps = {
  excelName: string;
  excelTableHead: string[];
  excelData: any[];
  nameOfBtn?: string;
};
const ExcelGenerator = ({
  excelName,
  excelTableHead,
  excelData,
  nameOfBtn,
}: IProps) => {
  const [loading, setLoading] = useState(false);
  const workbook = new Excel.Workbook();

  const saveExcel = async () => {
    setLoading(true);
    try {
      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(`${excelName}`);
      const titleRow = worksheet.addRow(excelTableHead);
      titleRow.eachCell((cell: any) => {
        cell.font = { bold: true };
      });
      titleRow.eachCell((cell: any) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
      });

      // Set column widths
      worksheet.columns.forEach((column: any) => {
        column.width = 25; // Set column width to 30 units
      });
      // Populate data rows
      excelData.forEach((rowData: any) => {
        const values = excelTableHead.map((header: any) => rowData[header]);
        const row = worksheet.addRow(values);

        // Set row height
        row.height = 25; // Set row height to 25 units

        // Apply cell formatting
        row.eachCell((cell: any) => {
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
        });
      });

      const excelDataGenerate = await workbook.xlsx.writeBuffer();
      // download the processed file
      saveAs(new Blob([excelDataGenerate]), `${excelName}.xlsx`);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.error('Something Went Wrong', error.message);
    }
  };
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <span
          style={{
            backgroundColor: '#1982c3',
            color: 'white',
            padding: '7px 7px',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            if (excelData?.length) saveExcel();
          }}
        >
          <FaFileExcel className='mb-1 me-1 ' />
          {nameOfBtn || 'Download'}
        </span>
      )}
    </div>
  );
};

export default ExcelGenerator;
